import DictionaryIcon_Trans from "../../../assets/UI/DictionaryIcon_Trans.png";
import SearchBarDictionary from "../DictionaryComponents/SearchBar_Dictionary/SearchBar_Dictionary";
import "../Dictionary.css";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";
import WordGrid from "../DictionaryComponents/WordGrid/WordGrid";
import { BasicColors } from "../../../SubjectData/BasicWords/Colors";
import { OtherColors } from "../../../SubjectData/BasicWords/Colors";
import Popup from "../../../Components/Popup/Dictionary_Popup";
import {useState} from "react";

export default function ColorsDictionary(){

    const [openPopup, setOpenPopup] = useState(null);

    const allData = [...BasicColors, ...OtherColors];
    
        return(
       
               <div>
                   <HeaderNavNTM GoBack_to="/ColorsNav"/>
                   <div className="blue-header-dict">
                       
                       <img className="DictionaryImage" src={DictionaryIcon_Trans} alt="Dictionary"></img>
                      
                         <SearchBarDictionary data={allData} onSelectItem={setOpenPopup} />
                       
                   </div>
       
                   <div>
                       
                       <WordGrid data={BasicColors} title="Basic Colors" onSelectItem={setOpenPopup} />
                       <WordGrid data={OtherColors} title="Other Colors" onSelectItem={setOpenPopup} />    
                       <Popup item={openPopup} onClose={() => setOpenPopup(null)} />
                  
                   </div>
                   
               </div>
       
           );
       
       }
       
    
    
    //Resources
        //Making a search bar
            //https://builtin.com/articles/react-search-bar